(function () {
  'use strict';

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function priceValue(value, isCents) {
    var parsed = Number.parseFloat(String(value || '').replace(/[^0-9.-]/g, ''));
    if (!Number.isFinite(parsed)) return 0;
    return isCents ? parsed / 100 : parsed;
  }

  function money(value) {
    return '$' + value.toFixed(2);
  }

  function getVariant(product) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    return variants.find(function (variant) {
      return variant.available;
    }) || variants[0] || null;
  }

  function productImage(product) {
    return product.featured_image || (product.images && product.images[0]) || '';
  }

  function imageUrl(value, width) {
    var raw = String(value || '');
    if (!raw) return '';
    var widthPattern = /([?&])width=\d+/;
    if (widthPattern.test(raw)) {
      return raw.replace(widthPattern, '$1width=' + width);
    }
    return raw + (raw.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function imageSrcset(value) {
    return [258, 360, 540].map(function (width) {
      return imageUrl(value, width) + ' ' + width + 'w';
    }).join(', ');
  }

  function comparePriceValue(item, variant, isCents) {
    var raw = variant && variant.compare_at_price != null
      ? variant.compare_at_price
      : item.compare_at_price;
    return priceValue(raw, isCents);
  }

  function renderItem(item, checked, disabled, priceInCents, isCurrentProduct) {
    var image = productImage(item);
    var variant = getVariant(item);
    var price = priceValue(item.price, priceInCents);
    var comparePrice = comparePriceValue(item, variant, priceInCents);
    var regularPrice = Math.max(price, comparePrice);
    var imageSrc = imageUrl(image, 360);
    var imageMarkup = image
      ? '<img class="jp-fbt__item-image" src="' +
        escapeHtml(imageSrc) +
        '" srcset="' +
        escapeHtml(imageSrcset(image)) +
        '" sizes="(max-width: 749px) 258px, 304px" alt="' +
        escapeHtml(item.title || '') +
        '" loading="lazy" decoding="async">'
      : '';
    if (imageMarkup && item.url) {
      imageMarkup =
        '<a class="jp-fbt__item-image-link" href="' +
        escapeHtml(item.url) +
        '" aria-label="View ' +
        escapeHtml(item.title) +
        '">' +
        imageMarkup +
        '</a>';
    }
    var currentProductLabel = isCurrentProduct && imageMarkup
      ? '<span class="jp-fbt__current-label">Current product</span>'
      : '';
    return (
      '<article class="jp-fbt__item" data-jp-fbt-item data-variant-id="' +
      escapeHtml(variant ? variant.id : '') +
      '" data-price="' +
      price.toFixed(2) +
      '" data-compare-price="' +
      regularPrice.toFixed(2) +
      '">' +
      '<input class="jp-fbt__check" type="checkbox" data-jp-fbt-check ' +
      (checked ? 'checked ' : '') +
      (disabled ? 'disabled ' : '') +
      'aria-label="Add ' +
      escapeHtml(item.title) +
      '">' +
      '<span class="jp-fbt__checkmark" aria-hidden="true"></span>' +
      currentProductLabel +
      imageMarkup +
      '<p class="jp-fbt__item-title">' +
      escapeHtml(item.title) +
      '</p>' +
      '<div class="jp-fbt__item-price">' +
      '<strong>' +
      money(price) +
      '</strong>' +
      (regularPrice > price
        ? '<s>' + money(regularPrice) + '</s>'
        : '') +
      '</div></article>'
    );
  }

  function renderBaseItem(widget) {
    var item = {
      id: widget.dataset.productId,
      title: widget.dataset.baseTitle,
      featured_image: widget.dataset.baseImage,
      url: widget.dataset.baseUrl,
      price: widget.dataset.basePrice,
      compare_at_price: widget.dataset.baseComparePrice,
      variants: [{ id: widget.dataset.baseVariantId, available: true }]
    };
    return renderItem(item, true, true, false, true);
  }

  function updateTotal(widget) {
    var total = 0;
    var originalTotal = 0;
    var selected = Array.from(widget.querySelectorAll('[data-jp-fbt-check]:checked'));
    selected.forEach(function (checkbox) {
      var item = checkbox.closest('[data-jp-fbt-item]');
      total += priceValue(item && item.dataset.price);
      originalTotal += Math.max(
        priceValue(item && item.dataset.price),
        priceValue(item && item.dataset.comparePrice)
      );
    });
    var thumbnails = widget.querySelector('[data-jp-fbt-thumbnails]');
    if (thumbnails) {
      thumbnails.innerHTML = selected.map(function (checkbox, index) {
        var item = checkbox.closest('[data-jp-fbt-item]');
        var image = item && item.querySelector('.jp-fbt__item-image');
        if (!image) return '';
        return (index > 0
          ? '<span class="jp-fbt__selected-plus" aria-hidden="true">+</span>'
          : '') +
          '<img class="jp-fbt__selected-thumbnail" src="' +
          escapeHtml(image.getAttribute('src')) +
          '" alt="" loading="lazy">';
      }).join('');
    }
    var countElement = widget.querySelector('[data-jp-fbt-count]');
    if (countElement) countElement.textContent = String(selected.length);
    var currentTotalElements = widget.querySelectorAll('[data-jp-fbt-current-total]');
    currentTotalElements.forEach(function (element) {
      element.textContent = money(total);
    });
    var savings = Math.max(0, originalTotal - total);
    var savingsElement = widget.querySelector('[data-jp-fbt-savings]');
    if (savingsElement) savingsElement.textContent = money(savings);
    var savingsContainer = widget.querySelector('.jp-fbt__summary-savings');
    if (savingsContainer) savingsContainer.hidden = savings <= 0;
    var addLabel = widget.querySelector('[data-jp-fbt-add-label]');
    if (addLabel) addLabel.textContent = 'Add ' + selected.length + ' To Cart';
  }

  /* JP-FBT-SAVED-COMBO-START */
  function fetchShopifyRecommendations(widget) {
    if (!/^\d+$/.test(String(widget.dataset.productId || ''))) {
      return Promise.resolve([]);
    }
    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root : '/';
    var url = new URL(String(root || '/') + 'recommendations/products.json', window.location.origin);
    if (url.origin !== window.location.origin) {
      return Promise.reject(new Error('Recommendation endpoint must be same-origin'));
    }
    url.searchParams.set('product_id', widget.dataset.productId);
    url.searchParams.set('limit', '6');
    url.searchParams.set('intent', 'related');
    var controller = new AbortController();
    var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
    return fetch(url.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Shopify recommendation request failed');
      return response.json();
    }).then(function (payload) {
      if (!Array.isArray(payload.products)) throw new Error('Invalid Shopify recommendation response');
      return payload.products;
    }).finally(function () {
      window.clearTimeout(timeout);
    });
  }

  function availableRecommendations(products, widget) {
    var seen = {};
    return products.filter(function (item) {
      var variant = item && getVariant(item);
      if (!item || !item.id || String(item.id) === String(widget.dataset.productId) ||
        seen[String(item.id)] || item.available === false || !variant || variant.available === false) {
        return false;
      }
      seen[String(item.id)] = true;
      return true;
    }).slice(0, 2);
  }

  function loadRecommendations(widget) {
    var itemsElement = widget.querySelector('[data-jp-fbt-items]');
    if (!itemsElement || widget.dataset.baseAvailable === 'false') return;

    function initializeControls() {
      updateTotal(widget);
      itemsElement.addEventListener('change', function (event) {
        if (event.target.matches('[data-jp-fbt-check]')) updateTotal(widget);
      });
      var button = widget.querySelector('[data-jp-fbt-add]');
      if (button) button.disabled = false;
    }

    // Keep Liquid-rendered links, prices and cards intact; no product JSON fetches.
    if (widget.dataset.renderedAi === 'true' &&
      itemsElement.querySelectorAll('[data-jp-fbt-item]').length > 1) {
      widget.dataset.recommendationSource = 'ai';
      widget.hidden = false;
      initializeControls();
      return;
    }

    fetchShopifyRecommendations(widget)
      .then(function (products) {
        widget.dataset.recommendationSource = 'shopify';
        return availableRecommendations(products, widget);
      })
      .then(function (recommendations) {
        if (recommendations.length === 0) return;

        itemsElement.innerHTML =
          renderBaseItem(widget) +
          recommendations.map(function (item) {
            return renderItem(item, true, false, true);
          }).join('');
        widget.hidden = false;
        initializeControls();
      })
      .catch(function (error) {
        console.warn('[Frequently Bought Together] Recommendations unavailable:', error.message);
        // No unavailable products or broken cart buttons are shown.
      });
  }

  function createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function (resolvePromise, rejectPromise) {
      resolve = resolvePromise;
      reject = rejectPromise;
    });
    return { promise: promise, resolve: resolve, reject: reject };
  }

  function dispatchCartUpdate(widget, items, deferred) {
    var event = new CustomEvent('shopify:cart:lines-update', {
      bubbles: true,
      cancelable: true
    });
    event.action = 'add';
    event.context = 'product';
    event.lines = items.map(function (item) {
      return { merchandiseId: String(item.id), quantity: item.quantity };
    });
    event.promise = deferred.promise;
    widget.dispatchEvent(event);
  }

  function setAddedState(button, widget) {
    var resetTimeout = Number(button.dataset.resetTimeout);
    if (resetTimeout) window.clearTimeout(resetTimeout);

    button.dataset.added = 'true';
    button.disabled = false;
    widget.querySelector('[data-jp-fbt-status]').textContent = '';

    button.dataset.resetTimeout = String(window.setTimeout(function () {
      delete button.dataset.resetTimeout;
      delete button.dataset.added;
      widget.querySelector('[data-jp-fbt-status]').textContent = '';
    }, 2500));
  }

  function addSelected(widget) {
    var button = widget.querySelector('[data-jp-fbt-add]');
    var status = widget.querySelector('[data-jp-fbt-status]');
    var items = Array.from(widget.querySelectorAll('[data-jp-fbt-check]:checked')).map(function (checkbox) {
      var item = checkbox.closest('[data-jp-fbt-item]');
      return { id: Number(item.dataset.variantId), quantity: 1 };
    }).filter(function (item) {
      return Number.isFinite(item.id) && item.id > 0;
    });
    if (!items.length) return;

    button.disabled = true;
    status.textContent = '';
    var deferred = createDeferred();
    dispatchCartUpdate(widget, items, deferred);
    var sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (element) {
        return element.dataset.sectionId;
      })
      .filter(Boolean);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sectionIds.join(',')
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart add failed');
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'cart add failed');
        }
        return fetch('/cart.js', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        }).then(function (cartResponse) {
          if (!cartResponse.ok) throw new Error('cart refresh failed');
          return cartResponse.json().then(function (cart) {
            deferred.resolve({
              cart: { totalQuantity: cart.item_count },
              detail: {
                didError: false,
                items: cart.items,
                sections: response.sections,
                source: 'jp-frequently-bought',
                sourceId: 'jp-frequently-bought',
                itemCount: items.reduce(function (total, item) {
                  return total + item.quantity;
                }, 0)
              }
            });
            setAddedState(button, widget);
          });
        });
      })
      .catch(function (error) {
        deferred.reject(error);
        button.disabled = false;
        status.textContent = 'Unable to add the selected products. Please try again.';
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-jp-fbt]').forEach(loadRecommendations);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-jp-fbt-add]');
    if (button) addSelected(button.closest('[data-jp-fbt]'));
  });
}());